module.exports = __webpack_public_path__ + "img/ubank.bfdf1cf1.png";